import FilterBadge from "./filterBadge";

export default {
    components: {
        FilterBadge: FilterBadge
    },
    props: {
        setFilter: Function,
        resetFilter: Function,
        activeFilter: Array,
        filterIcons: Object,
        activeOption: String,
        optionIcons: Object,
        sizeOptions: Array,
        typeOptions: Array,
        selectedOptions: Array,
        totalItemCount: Number,
        itemCount: Number,
        i18n: Object,
    },
    data() {
        return {
            activeTab: null,
        };
    },
    computed: {
        activeSizeFilters() {
            return (this.activeFilter || []).filter((x) => x.property === "size").length;
        },
        activeTypeFilters() {
            return (this.activeFilter || []).filter((x) => x.property === "type").length;
        }
    },
    methods: {
        changeTab(newTab) {
            this.activeTab = newTab;
        },
        getIcon(name) {
            return this.optionIcons[name];
        },
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        isActive(property, value) {
            const index = this.activeFilter.findIndex((filter) => {
                return filter.property === property && filter.value === value;
            });

            return index >= 0;
        },
    },
    template: `
        <div class="row">
        <div class="col-6 d-none d-sm-block">
            <p class="text-muted smaller">{{ i18n.browseByCategory }}</p>
        </div>
        <div class="col-12 col-sm-6">
            <p class="text-muted smaller text-sm-end">
                <strong>{{ itemCount }}</strong> of <strong>{{ totalItemCount }}</strong> Results <a
                @click.prevent="$emit('resetFilter')"
                class="ms-50"
                :class="{'opacity-25': activeFilter.length === 0}"
                href="#"
            >Reset filter</a>
            </p>
        </div>
        </div>
        <ul class="list-unstyled row g-1 g-lg-2">
            <li class="col-4">
                <div class="form-check form-check-xl d-md-flex text-center text-md-start p-1">
                    <input @change="changeTab(null)" class="form-check-input" type="radio" name="breedRadioFilter"
                           id="breedNameRadioFilter" :checked="activeTab==null">
                    <img width="51" height="56" :src="filterIcons.name" class="img-fluid me-md-1" :alt="i18n.filter.name">
                    <label class="form-check-label mt-50 mt-md-0" for="breedNameRadioFilter" id="breedNameFilter">
                        <small class="text-muted">{{ i18n.browseBy }}</small><span
                        class="h6 m-0">{{ i18n.filter.name }}</span>
                    </label>
                </div>
            </li>
            <li class="col-4">
                <div class="form-check form-check-xl d-md-flex text-center text-md-start p-1">
                    <input @change="changeTab('size')" class="form-check-input" type="radio" name="breedRadioFilter"
                           id="breedSizeRadioFilter" :checked="activeTab==='size'">
                    <img width="51" height="56" :src="filterIcons.size" class="img-fluid me-md-1" :alt="i18n.filter.size">
                    <label class="form-check-label mt-50 mt-md-0" for="breedSizeRadioFilter" id="breedSizeFilter">
                        <small class="text-muted">{{ i18n.browseBy }}</small>
                        <span class="h6 m-0">{{ i18n.filter.size }}
                            <FilterBadge :number="activeSizeFilters"/></span>
                    </label>
                </div>
            </li>
            <li class="col-4">
                <div class="form-check form-check-xl d-md-flex text-center text-md-start p-1">
                    <input @change="changeTab('type')" class="form-check-input" type="radio" name="breedRadioFilter"
                           id="breedTypeRadioFilter" :checked="activeTab==='type'">
                    <img width="51" height="56" :src="filterIcons.type" class="img-fluid me-md-1" :alt="i18n.filter.type">
                    <label class="form-check-label mt-50 mt-md-0" for="breedTypeRadioFilter" id="breedTypeFilter">
                        <small class="text-muted">{{ i18n.browseBy }}</small>
                        <span class="h6 m-0">{{ i18n.filter.type }}
                            <FilterBadge :number="activeTypeFilters"/></span>
                    </label>
                </div>
            </li>
        </ul>
        <div :class="{'breedSizeFilter': true, 'd-none': activeTab!=='size'}">
            <hr class="my-2">
            <ul class="list-unstyled row flex-wrap mb-0 gx-1 g-sm-0 min-height-85">
                <li class="col-6 col-sm-auto mb-sm-50 me-sm-50 mb-md-1 me-md-1" v-for="({label, value}) in sizeOptions">
                    <div class="form-check form-check-xl d-flex p-50 ps-50 pe-1 p-md-75 ps-md-75 pe-md-2">
                        <input class="form-check-input" type="checkbox"
                               @change="$emit('setFilter', {property: 'size', value})" :id="'size-' + value"
                               :checked="isActive('size', value)">
                        <img v-if="getIcon(value) != null" width="55" height="48" :src="getIcon(value)"
                             class="img-fluid svg me-lg-25" :alt="label">
                        <label class="form-check-label text-muted" :for="'size-' + value">
                            <strong>{{ label }}</strong>
                        </label>
                    </div>
                </li>
            </ul>
        </div>
        <div :class="{'breedTypeFilter': true, 'd-none': activeTab!=='type'}">
            <hr class="my-2">
            <ul class="list-unstyled row flex-wrap mb-0 gx-0 g-sm-0 min-height-85">
                <li class="col-auto mb-50 me-75 mb-md-1 me-md-1" v-for="({label, value}) in typeOptions">
                    <div class="form-check form-check-xl d-flex py-75 py-lg-1 px-1">
                        <input class="form-check-input" type="checkbox"
                               @change="$emit('setFilter', {property: 'type', value})" :id="'type-' + value"
                               :checked="isActive('type', value)">
                        <label class="form-check-label text-muted" :for="'type-' + value">
                            <strong>{{ label }}</strong>
                        </label>
                    </div>
                </li>
            </ul>
        </div>
    `
}
